export type Scopes = string | string[] | null;

// NOTE: (bwilytsch): IDs with this prefix are only used internally
// and should not be passed to the rest of the system
export const TEMP_PREFIX = "tmp_";

export function createInternalId(id: string): string {
	return `${TEMP_PREFIX}${id}`;
}

export function parseSubjectId(hash: SubjectHash): string | null {
	// Filter out internal IDs
	if (hash.value.startsWith(TEMP_PREFIX)) {
		return null;
	}

	return hash.id;
}

export class SubjectHash {
	private readonly scopes: string[];
	private readonly delimiter: string = "";

	constructor(id: string);
	constructor(id: [id: string, ...scope: string[]], delimiter?: string);
	constructor(
		id: string | [id: string, ...scope: string[]],
		delimiter: string = "",
	) {
		if (id.length === 0) {
			throw new Error(
				"Hash must have at least the `id` chunk and be of length > 0",
			);
		}

		this.scopes = Array.isArray(id) ? id : [id];
		this.delimiter = delimiter;
	}

	get value(): string {
		return this.scopes.join(this.delimiter);
	}

	get id(): string {
		return this.scopes[0];
	}

	toString(): string {
		return this.value;
	}
}
